import classNames from 'classnames';
import React from 'react';
import { SvgIcon } from 'ui/SvgIcon';
import ChevronDownIcon from 'ui/Icons/tabler/chevron-down.component.svg';

export interface iButtonWithDropdownProps {
  buttonLabel: React.ReactNode;
  buttonClassName?: string;
  dropdownClassName?: string;
  dropdownPanelClassName?: string;
  dropdownPosition?: 'left' | 'right';
  closeOnSelect?: boolean;
  dropdownOptions: {
    label: React.ReactNode;
    onClick: () => void;
    showTopBorder?: boolean;
  }[];
  showChevron?: boolean;
}

export const ButtonWithDropdown = (props: iButtonWithDropdownProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { showChevron = true } = props;
  return (
    <>
      <button
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        className={classNames(
          'border-none m-0 p-0 px-3 py-2 bg-transparent font-hurmegeometric-sans text-15px hover:bg-gray-10 rounded-3px uppercase cursor-pointer box-border',
          props.buttonClassName
        )}
      >
        <span
          className={classNames({
            'flex items-center gap-2': showChevron === true,
            'flex items-center justify-center': showChevron !== true,
          })}
        >
          <span>{props.buttonLabel}</span>
          {showChevron === true && (
            <span
              className={classNames('transition-transform', {
                'rotate-180': isOpen,
              })}
            >
              <SvgIcon IconComponent={ChevronDownIcon} className="w-3 fill-transparent stroke-current stroke-2" />
            </span>
          )}
        </span>
      </button>
      {isOpen && (
        <div className="relative">
          <div
            className={classNames(
              'absolute top-0 z-10 bg-white w-max',
              {
                'right-0': props.dropdownPosition === 'left',
                'left-0': props.dropdownPosition !== 'left',
              },
              props.dropdownPanelClassName
            )}
          >
            <div className="flex flex-col">
              {props.dropdownOptions.map(option => {
                return (
                  <button
                    onClick={() => {
                      option.onClick();
                      if (props.closeOnSelect === true) {
                        setIsOpen(false);
                      }
                    }}
                    className={classNames(
                      'm-0 p-0 px-3 py-2 bg-transparent font-hurmegeometric-sans text-15px hover:bg-gray-10 rounded-3px uppercase cursor-pointer box-border',
                      {
                        'border-t border-gray-10': option.showTopBorder,
                      },
                      props.dropdownClassName
                    )}
                  >
                    {option.label}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
